import { render, staticRenderFns } from "./ProductVariantStamp.vue?vue&type=template&id=3a8bfdfb&scoped=true&lang=pug"
import script from "./ProductVariantStamp.vue?vue&type=script&lang=js"
export * from "./ProductVariantStamp.vue?vue&type=script&lang=js"
import style0 from "./ProductVariantStamp.vue?vue&type=style&index=0&id=3a8bfdfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8bfdfb",
  null
  
)

export default component.exports